import script from "./purchaseListTab.vue?vue&type=script&setup=true&name=purchaseListTab&lang=js"
export * from "./purchaseListTab.vue?vue&type=script&setup=true&name=purchaseListTab&lang=js"

const __exports__ = script;

export default __exports__